import React, { useState } from 'react';
import { Box, Button, IconButton, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import KanbanBoard from './KanbanBoard';
import { FUNCTIONAL_DEPARTMENT_TABS, SUB_VIEW_TABS } from './constants';
import '../initiatives.scss';

const FunctionalInitiativesPage = () => {
  const [department, setDepartment] = useState(FUNCTIONAL_DEPARTMENT_TABS[0].key);
  const [subView, setSubView] = useState(SUB_VIEW_TABS[0].key);
  const [createOpen, setCreateOpen] = useState(false);

  const activeDept = FUNCTIONAL_DEPARTMENT_TABS.find((t) => t.key === department);
  const isBlank = Boolean(activeDept?.blank);

  return (
    <div className="initiatives-jklc">
      <Box className="initiatives-jklc__dept-tabs" sx={{ borderBottom: '1px solid #D9D9D9', mb: 1 }}>
        <Tabs
          value={department}
          onChange={(_, value) => {
            setDepartment(value);
            setSubView('kanban');
          }}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{ style: { backgroundColor: '#343c8c' } }}
        >
          {FUNCTIONAL_DEPARTMENT_TABS.map((tab) => (
            <Tab key={tab.key} value={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {isBlank ? (
        <Box className="initiatives-jklc__empty">No initiatives configured for this department.</Box>
      ) : (
        <Box>
          <Box
            className="initiatives-jklc__sub-tabs"
            mt={1}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            gap={1}
          >
            <Tabs
              value={subView}
              onChange={(_, value) => setSubView(value)}
              TabIndicatorProps={{ style: { backgroundColor: '#215093', height: 2 } }}
            >
              {SUB_VIEW_TABS.map((tab) => (
                <Tab key={tab.key} value={tab.key} label={tab.label} />
              ))}
            </Tabs>

            {subView === 'kanban' && (
              <Box display="flex" alignItems="center" gap={1}>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setCreateOpen(true)}
                  sx={{
                    backgroundColor: '#215093',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': { backgroundColor: '#1a4078' },
                  }}
                >
                  Create Initiative
                </Button>
                <Tooltip title="View">
                  <IconButton
                    size="small"
                    sx={{
                      border: '1px solid #D0D5DD',
                      borderRadius: '6px',
                      bgcolor: '#fff',
                      width: 34,
                      height: 34,
                    }}
                  >
                    <MailOutlineIcon sx={{ fontSize: 18, color: '#344054' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Send">
                  <IconButton
                    size="small"
                    sx={{
                      border: '1px solid #D0D5DD',
                      borderRadius: '6px',
                      bgcolor: '#fff',
                      width: 34,
                      height: 34,
                    }}
                  >
                    <SendOutlinedIcon sx={{ fontSize: 18, color: '#344054' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </Box>

          <Box mt={2}>
            {subView === 'kanban' && (
              <KanbanBoard
                department={department}
                createOpen={createOpen}
                onCreateClose={() => setCreateOpen(false)}
              />
            )}
            {subView === 'impact' && (
              <Typography sx={{ color: '#6b7280', fontSize: 13, py: 4, textAlign: 'center' }}>
                Impact Analysis for {activeDept?.label} will appear here.
              </Typography>
            )}
          </Box>
        </Box>
      )}
    </div>
  );
};

export default FunctionalInitiativesPage;
